/**
 * @file order-section-fallback.tsx
 * @module app/modules/orders-delivery/components/order-details/order-section-fallback
 * @description Placeholder shown while a lazily loaded order details section (vehicle card,
 * timeline, payment summary) downloads. It keeps roughly the section's height so the page
 * does not jump when the real section appears.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

interface OrderSectionFallbackProps {
  height?: number;
}

const OrderSectionFallback = ({ height = 120 }: OrderSectionFallbackProps) => (
  <div
    className="od-skeleton"
    style={{ minHeight: height }}
    role="status"
    aria-label="Loading"
  />
);

export default OrderSectionFallback;
